import api from 'api';
import {get} from 'lodash';
import toast from 'react-hot-toast';
import {useMutation} from 'react-query';
type SendCustomerNotePayload = {
  text: string;
  customer_id: string;
};

const sendCustomerNote = async ({
  text,
  customer_id,
}: SendCustomerNotePayload) => {
  const payload = {
    text,
    customer_id,
    type: 'note',
  };
  const {data} = await api.post(`/customers/timeline/`, payload);
  return data;
};

export const useCustomerTimeline = ({
  customer_id,
  refetch,
}: {
  customer_id: string;
  refetch: () => void;
}) => {
  const {mutateAsync: sendCustomerNoteMutation, isLoading} = useMutation({
    mutationFn: sendCustomerNote,
    onSuccess: () => {
      refetch();
      toast.success('Note added successfully');
    },
    onError: (error) => {
      const message = get(error, 'response.data.detail', 'Failed to add note');
      toast.error(message);
    },
  });

  const onSendCustomerNote = async (text: string) => {
    await sendCustomerNoteMutation({text, customer_id});
  };
  return {
    isLoading,
    onSendCustomerNote,
  };
};
